var _circle, _circle2, _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStarsCoin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58,
    height: 58,
    fill: "none",
    viewBox: "0 0 58 58"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 29,
    fill: "url(#paint0_linear)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 25,
    fill: "url(#paint1_linear)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint2_linear)",
    d: "M29.147 36.479L18.3 44.13l4.367-12.092-11.07-7.362 13.545.18 4.005-12.203 4.005 12.203 13.547-.18-11.072 7.362 4.368 12.092-10.848-7.652z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 58,
    x2: 58,
    y1: 58,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    stopColor: "#FDFA8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 28.444,
    x2: 28.444,
    y1: -1,
    y2: 59.556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    stopColor: "#B09100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E3700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 47.602,
    x2: 47.602,
    y1: 47.454,
    y2: 12.654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.001,
    stopColor: "#FDFA8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB400"
  })))));
}

SvgStarsCoin.displayName = 'StarsCoin';
export default SvgStarsCoin;